// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + (chunkId === 76 ? "common" : chunkId) + "." + {"76":"bd514c8d","240":"8b28ac3f","331":"67f714c8","679":"8bf8f000"}[chunkId] + ".chunk.css";
};